import React from "react";

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-brand">Sai Sruti</div>
        {/* <div className="footer-links">
          <a href="#about">About</a>
          <a href="#events">Events</a>
          <a href="#contact">Contact</a>
        </div> */}
        <div className="footer-copy">
          © {new Date().getFullYear()} Sai Sruti
        </div>
      </div>
    </footer>
  );
}
